String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

ko.bindingHandlers.fileUpload = {
    init: function(element, valueAccessor) {
        element.addEventListener('change', () => valueAccessor()(element.files[0]));
        element.addEventListener('click', (event) => event.target.value = null);
    },
    update: function(element, valueAccessor) {
        if (ko.unwrap(valueAccessor()) === null) {
            const form = document.createElement('form');
            element.parentNode.insertBefore(form, element);
            form.appendChild(element);
            form.reset();

            form.parentNode.insertBefore(element, form);
            form.remove();
        }
    }
};

var VM = function () {
    var self = this;
    self.optimization = ko.observable(false);
    self.fileSize = ko.observable();
    self.uploadFile = ko.observable(null);
    self.urlFile = ko.observable(null);
    self.previewFile = ko.observable(null);
    self.originalBase64 = ko.observable(null);
    self.htmlBase64 = ko.observable(null);
    self.cssBase64 = ko.observable(null);
    self.jsonBase64 = ko.observable(null);
    self.xmlBase64 = ko.observable(null);
    self.urlFileError = ko.observable(null);
    self.showResult = ko.observable(false);
    self.working = ko.observable(false);

    self.emptyInput = ko.pureComputed(function() {
        return self.urlFile() === "" || self.urlFile() === null;
    });
    self.fileName = ko.pureComputed(function(){
        if(self.uploadFile()) {
            return self.uploadFile().name;
        }
    });
    self.fileSizePretty = ko.pureComputed(function(){
        if(self.fileSize()) {
            return fileSize(self.fileSize());
        }
    });

    self.convertImageToBase64 = function() {
        self.clearForm();
        self.urlFile(null);
        if (self.uploadFile()) {
            var fileTypeSupport = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'image/bmp', 'image/x-icon'];
            if (fileTypeSupport.indexOf(self.uploadFile().type) === -1) {
                document.querySelector('.upload-box-input').classList.add('d-none');
                document.querySelector('.upload-box').classList.add('is-loading');
                setTimeout(function() {
                    document.querySelector('.upload-box-input').classList.remove('d-none');
                    document.querySelector('.upload-box').classList.remove('is-loading')
                    document.querySelector('.upload-box').classList.add('is-error', 'is-error-type');
                }, 500);
                return false;
            } else {
                if(self.uploadFile().size > 1048576) {
                    document.querySelector('.upload-box-input').classList.add('d-none');
                    document.querySelector('.upload-box').classList.add('is-loading');
                    setTimeout(function() {
                        document.querySelector('.upload-box-input').classList.remove('d-none');
                        document.querySelector('.upload-box').classList.remove('is-loading')
                        document.querySelector('.upload-box').classList.add('is-error', 'is-error-size');
                    }, 500);
                    return false;
                } else {
                    document.querySelector('.upload-box-input').classList.add('d-none');
                    document.querySelector('.upload-box').classList.add('is-loading');
                    var reader = new FileReader();
                    reader.onloadend = function(e) {
                        var imageDataUri = reader.result;
                        if (self.optimization() && self.uploadFile().type === 'image/png') {
                            var blob = new Blob([optipng(dataURLtoUint8(imageDataUri)).data], {type: 'image/png'});
                            self.fileSize(blob.size);
                            var re = new FileReader();
                            re.readAsDataURL(blob); 
                            re.onloadend = function() {
                                imageDataUri = re.result;
                                var mime = imageDataUri.match(/image.*(?=;)/g)[0];
                                var plain = imageDataUri.replace(/^data.*base64,/g, '');
                                setTimeout(function() { displayResult(imageDataUri, mime, plain, true); }, 1000);
                            }
                            return true;
                        } else {
                            var mime = imageDataUri.match(/image.*(?=;)/g)[0];
                            var plain = imageDataUri.replace(/^data.*base64,/g, '');
                            setTimeout(function() { displayResult(imageDataUri, mime, plain, true); }, 1000);
                        }
                    };
                    if (self.optimization() && self.uploadFile().type !== 'image/png') {
                        new Compressor(self.uploadFile(),
                            {
                                strict: true,
                                quality: 0.8,
                                success: function(result) {
                                    var file = new File([result], result.name, { type: result.type });
                                    self.fileSize(file.size);
                                    reader.readAsDataURL(file);
                                },
                                error: function(err) {
                                    console.log(err.message);
                                }
                            }
                        );
                    }
                    else {
                        reader.readAsDataURL(self.uploadFile());
                        self.fileSize(self.uploadFile().size);
                    }
                    return true;
                }
            }
        }
    };

    self.encodeURLToBase64 = function() {
        self.clearForm();
        self.uploadFile(null);

        var url = self.urlFile().replace(/^\s+|\s+$/, '');
        if(!url.match(/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.‌​\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[‌​6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1‌​,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00‌​a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u‌​00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i)) {
            self.urlFileError("Error: Not a valid URL !");
            document.querySelector('.url-box input').classList.add('is-invalid');
            return false;
        }

        var xhr = new XMLHttpRequest();
        xhr.onloadend = function(req) {
            self.working(true);
            if(req.target.status === 200) {
                if(req.target.response.size > 1048576) {
                    setTimeout(function() {
                        self.working(false);
                        self.urlFileError("Error: Image file size can not exceed 1 MB !");
                        document.querySelector('.url-box input').classList.add('is-invalid');
                    }, 500);
                    return false;
                } else {
                    if (req.target.response.type.indexOf("image") !=-1 ) {
                        var reader = new FileReader();
                        reader.onloadend = function() {
                            var imageDataUri = reader.result;
                            if (self.optimization() && xhr.response.type === 'image/png') {
                                var blob = new Blob([optipng(dataURLtoUint8(imageDataUri)).data], {type: 'image/png'});
                                self.fileSize(blob.size);
                                var re = new FileReader();
                                re.readAsDataURL(blob); 
                                re.onloadend = function() {
                                    imageDataUri = re.result;
                                    var mime = imageDataUri.match(/image.*(?=;)/g)[0];
                                    var plain = imageDataUri.replace(/^data.*base64,/g, '');
                                    setTimeout(function() { displayResult(imageDataUri, mime, plain, false); }, 1000);
                                }
                                return true;
                            } else {
                                var mime = imageDataUri.match(/image.*(?=;)/g)[0];
                                var plain = imageDataUri.replace(/^data.*base64,/g, '');
                                setTimeout(function() { displayResult(imageDataUri, mime, plain, false); }, 1000);
                            }
                        }
                        if (self.optimization() && xhr.response.type !== 'image/png') {
                            new Compressor(xhr.response,
                                {
                                    strict: true,
                                    quality: 0.8,
                                    success: function(result) {
                                        var file = new File([result], result.name, { type: result.type });
                                        self.fileSize(file.size);
                                        reader.readAsDataURL(file);
                                    },
                                    error: function(err) {
                                        console.log(err.message);
                                    }
                                }
                            );
                        } else {
                            reader.readAsDataURL(xhr.response);
                            self.fileSize(xhr.response.size);
                        }
                    } else {
                        self.working(false);
                        self.urlFileError("Error: The file is not an image !");
                        document.querySelector('.url-box input').classList.add('is-invalid');
                    }
                    return true;
                }
            }
        };
        xhr.onerror = function(e) {
            // do nothing
        };
        xhr.withCredentials = false;
        xhr.open('GET', 'https://api.allorigins.win/raw?url=' + self.urlFile(), true);
        xhr.responseType = 'blob';
        xhr.send();
    };

    self.formDragOver = function(data, event) {
        document.querySelector('.upload-box').classList.add('is-dragover');
    };
    self.formNotDragOver = function(data, event) {
        document.querySelector('.upload-box').classList.remove('is-dragover');
    };
    self.formDrop = function(data, event) {
        self.uploadFile(event.originalEvent.dataTransfer.files[0]);
        self.convertImageToBase64();
    }

    self.clearForm = function() {
        self.showResult(false);
        
        document.querySelector('.upload-box').classList.remove('is-loading', 'is-success', 'is-error', 'is-error-type', 'is-error-size');
        document.querySelector('.upload-box-input').classList.remove('d-none');
        document.querySelector('.url-box input').classList.remove('is-invalid');
        self.previewFile(null);
        self.originalBase64(null);
        self.htmlBase64(null);
        self.cssBase64(null);
        self.jsonBase64(null);
        self.xmlBase64(null);
        self.urlFileError(null);
    };

    // Copy to clipboard buttons
    new ClipboardJS('.btn-copy').on('success', function(evt) {
        evt.clearSelection();
        const cpyButton = new bootstrap.Tooltip(evt.trigger);
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    function dataURLtoUint8(dataurl) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return u8arr;
    }

    function fileSize(bytes) {
        var exp = Math.log(bytes) / Math.log(1024) | 0;
        var result = (bytes / Math.pow(1024, exp)).toFixed(2);

        return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY' [exp - 1] + 'B');
    }

    function displayResult(imageDataUri, mime, plain, dragDrop) {
        self.previewFile(imageDataUri);
        self.originalBase64(plain);
        self.htmlBase64('<img src="' + imageDataUri + '" />');
        self.cssBase64('background-image: url("' + imageDataUri + '");');
        self.jsonBase64('{\n' + '  "image": {\n' + '    "mime": ' + '"' + mime + '",\n' + '    "data": ' + '"' + plain + '"\n  }' + '\n}');
        self.xmlBase64('<?xml version="1.0" encoding="UTF-8"?>\n' + '<root>\n' + '  <image mime="' + mime + '">' + plain + '</image>' + '\n</root>');
        self.working(false);
        self.showResult(true);
        setTimeout(function() {
            scrollToResponse();
        }, 100);
        if (dragDrop) {
            document.querySelector('.upload-box-input').classList.remove('d-none');
            document.querySelector('.upload-box').classList.remove('is-loading')
            document.querySelector('.upload-box').classList.add('is-success');
        }
    }

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });

    function scrollToResponse() {
        // Remove loading animation
        if (document.querySelector('.loading-validator')) {
            document.querySelector('.loading-validator').classList.remove('d-block');
        }

        // Go to validated result
        const targetPosition = document.querySelector("#encoder-response").getBoundingClientRect().top + window.scrollY - 80;
        window.scroll({ top: targetPosition, behavior: 'smooth' });
    }
};

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    var Compressor = window.Compressor;

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});